<script>
	import { onMount } from 'svelte'

  export let email
  let tapped = false

  const onFirstTap = function(event){
    event.preventDefault()
    event.stopPropagation()
    tapped = true
  }

</script>
  {#if !tapped}
    <a href="#" on:click={onFirstTap}>Tap to email us</a>
  {:else}
    <a href="mailto:{email}">{email}</a>
  {/if}